import { render, staticRenderFns } from "./modal-add-page.vue?vue&type=template&id=60734482&scoped=true"
import script from "./modal-add-page.vue?vue&type=script&lang=js"
export * from "./modal-add-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60734482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60734482')) {
      api.createRecord('60734482', component.options)
    } else {
      api.reload('60734482', component.options)
    }
    module.hot.accept("./modal-add-page.vue?vue&type=template&id=60734482&scoped=true", function () {
      api.rerender('60734482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/modal-add-page.vue"
export default component.exports